<template
	><div class="k-component -team">
		<b-container>
			<b-row align-h="center">
				<b-col col lg="8" class="text-center">
					<h1 v-if="teamData.title">
						<span>{{ teamData.title }}</span>
					</h1>
					<h2 v-if="teamData.subtitle">{{ teamData.subtitle }}</h2>
					<div v-if="teamData.description" v-html="teamData.description"></div>
					<hr v-if="teamData.showCards" class="my-5" />
				</b-col>
			</b-row>
		</b-container>
		<b-container v-if="teamData.showCards">
			<b-row>
				<TeamItem v-for="itemData in teamData.items" :key="itemData.id" :item-data="itemData" />
			</b-row>
		</b-container>
	</div>
</template>

<script>
import TeamItem from '@/components/TeamItem.vue'

export default {
	name: 'Team',

	components: {
		TeamItem
	},

	props: {
		teamData: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-team.scss';
</style>
